import { z } from 'zod';

import { BorrowerAchAccountId, BorrowerId, LoanId } from '../BrandedIds';
import { zodDateOrString } from '../utils';

export const BorrowerAchAccount = z.object({
  id: BorrowerAchAccountId,
  borrowerId: BorrowerId,
  loanId: LoanId,
  accountName: z.string(),
  lastFour: z.string(),
  prenoteSubmittedAt: zodDateOrString.optional(),
  disabledAt: zodDateOrString.optional(),
  addedByCompany: z.boolean(),
  createdAt: z.date(),
});
export type BorrowerAchAccount = z.infer<typeof BorrowerAchAccount>;
